import { css } from "@emotion/react";

export const ismsImg = css`
  width: 56px;
  height: 40px;
  cursor: pointer;
`;
